import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,{attrs:{"outlined":"","dense":"","hide-details":"","min":"01:00","max":"03:00","type":"time","step":"0.001","label":"Result Time","hint":":mm:ss.mis"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})
}
var staticRenderFns = []

export { render, staticRenderFns }